module.exports = "<div>\n  <list-workwave-template-rebuild [templateToEdit]=\"workwaveToEdit\"></list-workwave-template-rebuild>\n</div>\n"